import { render, staticRenderFns } from "./ScheduleAddView.vue?vue&type=template&id=06f6b70f&scoped=true"
import script from "./ScheduleAddView.vue?vue&type=script&lang=js"
export * from "./ScheduleAddView.vue?vue&type=script&lang=js"
import style0 from "./ScheduleAddView.vue?vue&type=style&index=0&id=06f6b70f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6b70f",
  null
  
)

export default component.exports